export function createEmitter<T>(): Emitter<T> {
  let subscriptions: Array<(data: T) => void> = [];

  return {
    emit(data) {
      subscriptions.forEach((cb) => cb(data));
    },
    onEvent(callback) {
      subscriptions.push(callback);
      return () => {
        subscriptions = subscriptions.filter((cb) => cb !== callback);
      };
    },
  };
}

export interface Emitter<T> {
  emit(data: T): void;
  onEvent(callback: (data: T) => void): () => void;
}
